import React, { useState } from 'react';
import '../styles/transcribe.css'
import useGetResolution from '../functions/useGetResolution';
import TranscribeForm from '../components/transcribe-form';
import TranscribeUserInfo from '../components/transcribe-user-info';
import TranscribeMultimedia from '../components/transcribe-multimedia';
import TranscribeNotes from '../components/transcribe-notes';
import TranscripcionesList from '../components/transcripciones-list';
// import TranscribeDone from '../components/transcribe-done';
import der from "../img/der.png"
import notes from "../img/notes.png"
import writingWite from "../img/writing-white.png"
import document from "../img/document.png"
import { toast } from 'react-toastify';
import exit from "../img/exit.png"
const Transcribe = ({ setAuth }) => {
    const [filesToUploadList, setFilesToUploadList] = useState([]);
    const [principalImage, setPrincipalImage] = useState(writingWite);
    const resolution = useGetResolution();
    const logout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('auth');
        localStorage.removeItem('username');
        toast.info("La sesión ha sido cerrada")
        setAuth(false)
    }
    return (
        resolution === "sm" || resolution === "xs" ? (
            <div>
                <div className='item-decoration flex justify-center items-center'>
                    <img
                        className='principal-img'
                        src={principalImage}
                    /></div>
                <div className="carousel w-full">
                    <div id="item1" className="carrousel-page flex justify-center items-center carousel-item w-full">
                        <TranscribeForm
                            filesToUploadList={filesToUploadList}
                            setFilesToUploadList={setFilesToUploadList}
                        />
                    </div>
                    {/* <div id="item2" className="carrousel-page flex justify-center items-center carousel-item w-full">
                        <TranscribeDone
                            filesToUploadList={filesToUploadList}
                        />
                    </div> */}
                    <div id="item2" className="carrousel-page flex justify-center items-center carousel-item w-full">
                        <TranscripcionesList />
                    </div>
                    <div id="item3" className="carrousel-page flex justify-center items-center carousel-item w-full">
                        <TranscribeNotes/>
                    </div>
                </div>
                <div className="navigator flex justify-center w-full py-2 gap-2">
                    <a href="#item1" onClick={() => setPrincipalImage(writingWite)}>
                        <img
                            className='nav-img'
                            src={writingWite}
                        /></a>
                    <a href="#item2" onClick={() => setPrincipalImage(document)}>
                        <img
                            className='nav-img'
                            src={document}
                        />
                    </a>
                    <a href="#item3" onClick={() => { setPrincipalImage(notes) }}>
                        <img
                            className='nav-img'
                            src={notes}
                        />
                    </a>
                    <a href="#item4" onClick={() => { logout(); setPrincipalImage(writingWite) }}>
                        <img
                            className='nav-img'
                            src={exit}
                        />
                    </a>
                </div>
            </div>
        ) : (
            <div className='transcribe-component flex row-auto'>
                <TranscribeForm
                    filesToUploadList={filesToUploadList}
                    setFilesToUploadList={setFilesToUploadList}
                />
                {/* <TranscribeDone
                    filesToUploadList={filesToUploadList}
                /> */}
                 <div className="w-1/3 ml-8">
                    <TranscripcionesList />
                </div>
                <img
                    className='der-img'
                    src={der}
                />
            </div>
        )
    )
}

export default Transcribe;